<div class="container-x">
    <header>
        <img src="./assets/img/logo.png" alt="CertWallet log" class="logo" />
    </header>
    <main>
        <h1>Under Construction</h1>
        <p>We are making updates to improve our services and user experience.
            For urgent matters, feel free to contact us.</p>
        <a href="mailto:rickytheceo@getcertwallet.com" class="btn">Contact Us</a>
    </main>
</div>